<script setup>

import { inject } from 'vue';
import ListeListesValeurs from './listeListesValeurs/ListeListesValeurs.vue';
import DetailListeValeurs from './detailListeValeurs/DetailListeValeurs.vue';

const { listesValeurs } = defineProps({
  listesValeurs: Array
});

const selectionSchema = inject('selectionSchema');

</script>

<template>
	<div class="panel-lateral contenu-onglet-schema">
		<ListeListesValeurs :listesValeurs="listesValeurs" />
		<DetailListeValeurs v-if="selectionSchema.listeValeurs != null" :listeValeurs="selectionSchema.listeValeurs" />
	</div>
</template>

<style scoped>
</style>